module.exports = __webpack_public_path__ + "static/img/xaty.c6757d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xaty.png
// module id = aFyR
// module chunks = 1